export const parseLogisticKpiDataModal = (data: any[]): any[] => {
  return data?.length === 0
    ? []
    : data.map(item => {
        return {
          'categiria-compacta-nome-id': item.categoriaCompactaDescricao
            ? item.categoriaCompactaDescricao
            : '',

          'produto-codigo-id': item.produtoId ? item.produtoId : 0,
          'produto-nome-id': item.produtoDescricao ? item.produtoDescricao : '',

          'lead-time-cadastrado-id': item.tempoExecucaoSistema
            ? item.tempoExecucaoSistema
            : 0,
          'lead-time-realizado-id': item.tempoRealizado
            ? item.tempoRealizado
            : 0,

          'recebimentos-pedidos-id': item.pedidosUltimosDozeMeses
            ? item.pedidosUltimosDozeMeses
            : 0,
          'recebimentos-quantidade-id': item.quantidadeRecebida
            ? item.quantidadeRecebida
            : '',
          'subcategoria-codigo-id': item.subCategoriaId
            ? item.subCategoriaId
            : 0,
          'subcategoria-nome-id': item.subCategoriaDescricao
            ? item.subCategoriaDescricao
            : ''
        }
      })
}
